// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.home-post-widget{
    padding: var(--space-and-half) var(--space) var(--space) var(--space);
    background: var(--white-color);
    border-radius: 12px;
    margin-bottom: var(--space-and-half);
    box-shadow: 0px 3.02431px 3.02431px rgba(170, 193, 182, 0.32);
    display: flex;
    flex-wrap: wrap;
}

.home-post-widget__input{
    display: flex;
    width: 100%;
}

.home-post-widget__input__image{
    width: 50px;
    height: 50px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    margin-right: var(--space);
}

.home-post-widget__input__image img{
    width: 50px;
    height: 50px;
    border-radius: 50%;
}

.home-post-widget__input__image .icon-ball{
    font-size: 40px;
    font-weight: var(--font-bold);
    border-radius: 50%;
    padding: 5px;
    height: 50px;
    color: var(--white-color);
}

.home-post-widget__input__input{
    background: var(--new-gray-background-color);
    border-radius: var(--space-x3);
    height: var(--space-x3);
    width: 100%;
    padding-top: var(--space-half-quarter);
    padding-bottom: var(--space-half-quarter);
    padding-left: var(--space-and-half);
    cursor: pointer;
}

.home-post-widget__input__input.baloa-names{
    color: var(--basic-gray-color);
}

.home-post-widget__separator{
    width: 100%;
    height: 0;
    border-top: 1px solid var( --new-gray-background-color );
    margin-top: var( --space );
    margin-bottom: var( --space-half );
}

.home-post-widget__buttons{
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.home-post-widget__buttons__button{
    display: flex;
    align-items: center;
    cursor: pointer;
}
.home-post-widget__buttons .icon-image-70 {
    font-size: var(--space-x2);
    color: #64B5F6;
}
.home-post-widget__buttons .icon2-video-offer {
    font-size: var(--space-x2);
    color: #F77B73;
}
.home-post-widget__buttons .icon-field {
    font-size: var(--space-x2);
    color: #6ECB96;
}

.home-post-widget__buttons .baloa-names{
    color: var(--basic-gray-color);
    font-weight: var(--font-medium);
    padding-left: var(--space-half);
}

@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */ 
    .home-post-widget{
        border-radius: 0 0 var(--space) var(--space);
        margin-bottom: 0;
    }
}`, "",{"version":3,"sources":["webpack://./src/app/home/components/home-post-widget/HomePostWidgetComponent.styles.css"],"names":[],"mappings":"AAAA;IACI,qEAAqE;IACrE,8BAA8B;IAC9B,mBAAmB;IACnB,oCAAoC;IACpC,6DAA6D;IAC7D,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,WAAW;AACf;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,0BAA0B;AAC9B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,6BAA6B;IAC7B,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,4CAA4C;IAC5C,8BAA8B;IAC9B,uBAAuB;IACvB,WAAW;IACX,sCAAsC;IACtC,yCAAyC;IACzC,mCAAmC;IACnC,eAAe;AACnB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,WAAW;IACX,SAAS;IACT,wDAAwD;IACxD,0BAA0B;IAC1B,kCAAkC;AACtC;;AAEA;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;AACnB;AACA;IACI,0BAA0B;IAC1B,cAAc;AAClB;AACA;IACI,0BAA0B;IAC1B,cAAc;AAClB;AACA;IACI,0BAA0B;IAC1B,cAAc;AAClB;;AAEA;IACI,8BAA8B;IAC9B,+BAA+B;IAC/B,+BAA+B;AACnC;;AAEA,yCAAyC,4BAA4B;IACjE;QACI,4CAA4C;QAC5C,gBAAgB;IACpB;AACJ","sourcesContent":[".home-post-widget{\n    padding: var(--space-and-half) var(--space) var(--space) var(--space);\n    background: var(--white-color);\n    border-radius: 12px;\n    margin-bottom: var(--space-and-half);\n    box-shadow: 0px 3.02431px 3.02431px rgba(170, 193, 182, 0.32);\n    display: flex;\n    flex-wrap: wrap;\n}\n\n.home-post-widget__input{\n    display: flex;\n    width: 100%;\n}\n\n.home-post-widget__input__image{\n    width: 50px;\n    height: 50px;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    margin-right: var(--space);\n}\n\n.home-post-widget__input__image img{\n    width: 50px;\n    height: 50px;\n    border-radius: 50%;\n}\n\n.home-post-widget__input__image .icon-ball{\n    font-size: 40px;\n    font-weight: var(--font-bold);\n    border-radius: 50%;\n    padding: 5px;\n    height: 50px;\n    color: var(--white-color);\n}\n\n.home-post-widget__input__input{\n    background: var(--new-gray-background-color);\n    border-radius: var(--space-x3);\n    height: var(--space-x3);\n    width: 100%;\n    padding-top: var(--space-half-quarter);\n    padding-bottom: var(--space-half-quarter);\n    padding-left: var(--space-and-half);\n    cursor: pointer;\n}\n\n.home-post-widget__input__input.baloa-names{\n    color: var(--basic-gray-color);\n}\n\n.home-post-widget__separator{\n    width: 100%;\n    height: 0;\n    border-top: 1px solid var( --new-gray-background-color );\n    margin-top: var( --space );\n    margin-bottom: var( --space-half );\n}\n\n.home-post-widget__buttons{\n    width: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n.home-post-widget__buttons__button{\n    display: flex;\n    align-items: center;\n    cursor: pointer;\n}\n.home-post-widget__buttons .icon-image-70 {\n    font-size: var(--space-x2);\n    color: #64B5F6;\n}\n.home-post-widget__buttons .icon2-video-offer {\n    font-size: var(--space-x2);\n    color: #F77B73;\n}\n.home-post-widget__buttons .icon-field {\n    font-size: var(--space-x2);\n    color: #6ECB96;\n}\n\n.home-post-widget__buttons .baloa-names{\n    color: var(--basic-gray-color);\n    font-weight: var(--font-medium);\n    padding-left: var(--space-half);\n}\n\n@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */ \n    .home-post-widget{\n        border-radius: 0 0 var(--space) var(--space);\n        margin-bottom: 0;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
